module.exports = __webpack_public_path__ + "static/media/jetpure-2.391ed0e2.jpg";